<div class="d-flex">
  <!-- Nav Bar -->
  <div AddsRtl id="header" class="row p-1 header">
    <div class="col-md-4 mb-0 d-flex align-items-center org-logo-col px-2">
      <a class="navbar-brand-logo" [routerLink]="['/modules']" aria-label="The Qualidad home">
        <img
          src="assets/qualidad/The Qualidad_white.png"
          alt="The Qualidad"
          class="navbar-qualidad-logo" />
      </a>
      <!-- Stakeholder organization logo, pinned to the outer edge of the bar
           (far right in RTL). Only shown when the backend returns an uploaded
           logo URL; otherwise nothing is displayed. -->
      <img
        *ngIf="organizationLogoUrl"
        [src]="organizationLogoUrl"
        alt="Organization Logo"
        class="navbar-org-logo" />
    </div>
    <div class="col-md-8">
      <ul class="nav-right">
        <!-- <li>
        
          <p-treeSelect
          class="w-full md:w-20rem"
          containerStyleClass="w-full"
          [(ngModel)]="selectedNode"
          [options]="nodes"
          display="chip"
          [metaKeySelection]="false"
          selectionMode="single" 
          placeholder="Select Item"
          [virtualScroll]="true"
          [virtualScrollItemSize]="46"
          [virtualScrollOptions]="{ scrollHeight: '200px' }"
          [filter]="true" 
    [filterInputAutoFocus]="true"
    (onNodeSelect)="onNodeSelect($event)"

        ></p-treeSelect>

        </li> -->
        <!-- date -->
        <li>
          <a class="lang" *ngIf="languageService.getLanguage == 'en'" (click)="changeLang('ar')">
            <span>العربية</span>
          </a>
          <a class="lang" *ngIf="languageService.getLanguage == 'ar'" (click)="changeLang('en')">
            <span>English</span>
          </a>
        </li>
        <!--    <li class="nav-icon">
          <img src="./assets/media/icons/calendar.svg" alt="" srcset="" />
          <span class="mx-2 main-color1">{{ currentDate | date: 'dd.MM.yyyy' }}
          </span>
        </li> -->
        <!-- Language -->
        <!--  <li class="nav-icon language-nav-icon">
          <a (click)="languageMenu.toggle($event)">
            <img src="./assets/media/icons/global.svg" alt="" srcset="" />
            <i class="fa-solid fa-globe"></i>
          </a>
        </li> -->



           <!-- Documents/Reports - Only for Project Heads and Project Admins -->
        <!-- DISABLED: reports pill hidden and its API calls stopped (heavy payload). To re-enable, remove this comment wrapper and the notificationsEnabled flag in nav-bar.component.ts.
        <!-- AI Assistant. Shown only to users holding the AiAssistant.Use privilege
             (B1F4C2D0-8E6A-4C31-9F77-2A5D1E93C401), confirmed by the API — see
             checkAiAssistantPrivilege(). The API enforces it on every AI endpoint as well. -->
        <li class="nav-icon" *ngIf="canUseAssistant">
          <a [routerLink]="['/ai-assistant']"
             title="AI Assistant"
             class="ai-assistant-link">
            <i class="fa-solid fa-robot"></i>
            <span class="ai-assistant-label">Assistant</span>
          </a>
        </li>

        <li class="nav-icon" #ReportsPill *ngIf="isPhead || isPAdmin">
          <div
            class="dropdown dropdown-toggle dropdown-main notification-container"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="ReportsPill">
            <img src="./assets/images/reports.png" class="notificationImage" alt="Reports" width="24" height="24" />
            <span
              class="notification-count badge bg-danger"
              *ngIf="reportsCount && reportsCount > 0"
              severity="danger"
              style="position: absolute; right: -8px; top: -5px; font-size: 10px;">{{ reportsCount }}</span>
            <div
              class="dropdown-menu overflow-x-hidden fixed-height-500 p-3 min-width-300"
              style="max-height: 400px;">
              <p *ngIf="!reports || reports.length === 0" class="text-center text-muted">{{ 'shared.noReportsAvailable' | translate }}</p>
              <a
                class="notification-item"
                *ngFor="let report of reports"
                [routerLink]="['/msm-checklist/action-plan/master', report.id]"
                style="background-color: #a39c9c; border-radius: 4px; margin-bottom: 8px;">
                <div>
                  <h6 class="mb-1 color-black" style="text-align: left">
                    {{ report.name }}
                  </h6>
                  <small style="color: white;">
                    <i class="fa fa-calendar" style="margin-right: 5px; color: white;" aria-hidden="true"></i>{{ report.createdOn | date:'EEE dd MMM yyyy' }}
                  </small>
                </div>
              </a>
            </div>
          </div>
        </li>
        <!-- Notification -->
        <!-- DISABLED: notifications bell hidden and its API calls stopped (heavy payload). To re-enable, remove this comment wrapper and the notificationsEnabled flag in nav-bar.component.ts.
        <li class="nav-icon" #NotificationPill>
          <div
            class="dropdown dropdown-toggle dropdown-main notification-container"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            (click)="addActiveNotification(NotificationPill)"
            id="NotificationPill">
            <img src="./assets/images/notification.png" class="notificationImage" alt="Notifications" width="24" height="24" />
            <span
              class="notification-count badge bg-danger"
              *ngIf="UnSeenNotifications && UnSeenNotifications > 0"
              severity="danger"
              style="position: absolute; right: -8px; top: -5px; font-size: 10px;">{{ UnSeenNotifications }}</span>
            <div
              class="dropdown-menu overflow-x-hidden fixed-height-500 p-3 min-width-300">
              <a
                class="notification-item"
                *ngFor="let item of notifications?.collection">
                <div>
                  <h6 class="mb-1 color-black" style="text-align: left">
                    {{ item.notTitle }}
                  </h6>
                  <p class="text-truncate max-380 m-0 not-body">
                    {{ item.notBody }}
                  </p>
                  <div class="d-flex">
                    <small></small>
                    <small class="text-grey">{{ item.creationDate | date }}</small>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </li>
        -->


        <!-- User Profile Dropdown Menu -->
        <li class="nav-icon user-menu-dropdown">
          <div
            class="dropdown user-profile-container"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            id="userProfileDropdown">

            <!-- User Info Display -->
            <div class="user-profile-display">
              <img
                *ngIf="currentUser?.profileImage"
                [src]="domainUrl + (currentUser?.profileImage || '')"
                alt="User"
                class="user-profile-image"
                onerror="this.src='./assets/images/user.png'" />
              <img
                *ngIf="!currentUser?.profileImage"
                src="./assets/images/user.png"
                alt="User"
                class="user-profile-image" />

              <span class="user-info-text">
                <span class="user-role">{{ currentUser?.roleName }}:</span>
                <span class="user-name">{{ currentUser?.userName || (currentUser?.firstName + ' ' + currentUser?.lastName) }}</span>
              </span>

              <i class="fa fa-angle-down dropdown-arrow"></i>
            </div>

            <!-- Dropdown Menu -->
            <ul class="dropdown-menu dropdown-usermenu" aria-labelledby="userProfileDropdown">
              <!-- Log Out -->
              <li>
                <a class="dropdown-item" (click)="openLogOut()">
                  <i class="fa fa-sign-out me-2"></i>
                  {{ 'shared.logOut' | translate }}
                </a>
              </li>

              <!-- Change Password - Only for non-AD users -->
              <li *ngIf="canChangePassword">
                <a class="dropdown-item" (click)="navigateToChangePassword()">
                  <i class="fa fa-lock me-2"></i>
                  {{ 'User.ChangePassword' | translate }}
                </a>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>
<!-- Modal -->
<div class="modal fade" data-bs-backdrop="static" id="logOutModel" tabindex="-1" aria-labelledby="deleteModelLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header border-0">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div class="mb-13 text-center">
          <h5 class="text-black">{{ 'shared.logOutMessage' | translate }}</h5>
        </div>
      </div>
      <div class="modal-footer border-0 mx-auto">
        <button type="button" class="btn btn-primary mx-1" data-bs-dismiss="modal" (click)="userLogout()">
          {{ 'shared.logOut' | translate }}
        </button>

        <button type="button" class="btn btn-cancel mx-1" data-bs-dismiss="modal">
          {{ 'shared.cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<!-- <p-menu #languageMenu [model]="languagesList" [popup]="true"></p-menu> -->